import React, { useEffect, useState } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import MessageDialog from "../../components/MessageDialog";
import StorageService from "../../services/StorageService";
import ProjectCategoryService from "../../services/ProjectCategoryService";
import ProjectService from "../../services/ProjectService";
import StoreService from "../../services/StoreService";
import LocationService from "../../services/LocationService";
import StockOutReportService from "../../services/stockOutReportService";
import utility from "../../utils/utility";
import XLSX from "xlsx-js-style";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from '../../assets/images/deviops_logo.png';
import { addPdfLogo, getPdfLogoDataUrl } from "../../utils/pdfLogo";
import ProjectStoreService from "../../services/ProjectStoreService";
import ProjectLocationService from "../../services/ProjectLocationService";

export default function StockOutReport() {
  const activeCompany = StorageService.activeCompany();
  const companyId = activeCompany?.companyId || "";
  const [projectCategoryId, setProjectCategoryId] = useState("");
  const [projectId, setProjectId] = useState("");
  const [storeId, setStoreId] = useState("");
  const [locationId, setLocationId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [status, setStatus] = useState("");

  const [projectCategories, setProjectCategories] = useState([]);
  const [projects, setProjects] = useState([]);
  const [stores, setStores] = useState([]);
  const [locations, setLocations] = useState([]);

  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");

  // ✅ PAGINATION STATES
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const selectedCategory = projectCategories.find(
    (cat) => String(cat.id) === String(projectCategoryId)
  );
  const selectedCategoryCode = selectedCategory?.categoryCode;

  const filteredProjects = projectCategoryId
    ? projects.filter((project) => {
      if (project.projectCategoryId) {
        return (
          String(project.projectCategoryId) ===
          String(projectCategoryId)
        );
      }
      return (
        project.projectCategoryCode ===
        selectedCategoryCode
      );
    })
    : [];






  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
  };

  const formatProjectDisplay = (project) => {
    if (!project) return "-";

    const projectName = project.projectName || project.name || "";
    const categoryName = project.projectCategoryName || project.categoryName || project.category || "";
    const projectCode = project.projectCode || "";
    const categoryInitial = String(categoryName).trim().charAt(0).toUpperCase();

    if (projectName) {
      if (categoryInitial) {
        return `${categoryInitial}*${projectName}`;
      }

      if (projectCode) {
        const codeInitial = String(projectCode).trim().charAt(0).toUpperCase();
        return `${codeInitial}*${projectName}`;
      }

      return projectName;
    }

    if (projectCode) {
      const codeInitial = String(projectCode).trim().charAt(0).toUpperCase();
      return `${codeInitial}*`;
    }

    return categoryInitial ? `${categoryInitial}*` : "-";
  };

  const loadDropdowns = async () => {
    try {
      const user = StorageService.loginData();
      let projectRes;

      if (Number(user?.roleId) === 1 || Number(user?.roleId) === 2) {
        // Super Admin & Data Admin
        projectRes = await ProjectService.getActive(companyId);
      } else {
        // Employee
        projectRes = await ProjectService.getAssignedProjects(
          companyId,
          user?.employeeId
        );
      }

      const [projectCategoryRes, storeRes, locationRes] = await Promise.all([
        ProjectCategoryService.getAll(),
        StoreService.getActive(),
        LocationService.getActive(),
      ]);

      setProjectCategories(projectCategoryRes?.data || projectCategoryRes || []);

      let projectList = [];
      if (Number(user?.roleId) === 1 || Number(user?.roleId) === 2) {
        projectList = Array.isArray(projectRes)
          ? projectRes
          : (projectRes?.data || []);
      } else {
        projectList = projectRes?.data?.data || [];
      }

      setProjects(projectList);
      setStores(storeRes?.data || storeRes || []);
      setLocations(locationRes?.data || locationRes || []);
    } catch (error) {
      console.error(error);
      setProjectCategories([]);
      setProjects([]);
      setStores([]);
      setLocations([]);
      showMessage("Failed to load filter dropdowns");
    }
  };

  const loadStoresByProject = async (projectId) => {
    if (!projectId) {
      setStores([]);
      return;
    }

    try {
      const res = await ProjectStoreService.getProjectStoreById(projectId);
      console.log("Project Stores:", res.data);

      setStores(res?.data || res || []);
    } catch (err) {
      console.error("Store load error", err);
      setStores([]);
    }
  };

  const loadLocationsByProjectAndStore = async (projectId, storeId) => {
    if (!projectId || !storeId) {
      setLocations([]);
      return;
    }

    try {
      const res = await ProjectLocationService.getByProjectAndStore(projectId, storeId);
      setLocations(res?.data || []);
    } catch (err) {
      console.error("Location load error", err);
      setLocations([]);
    }
  };

  const loadReport = async (pageNumber = page) => {

    if (projectCategoryId || projectId) {
      if (!projectCategoryId) {
        showMessage("Project Category is required");
        return;
      }

      if (!projectId) {
        showMessage("Project Name is required");
        return;
      }
    }

    if (startDate && !endDate) {
      showMessage("From Date and To Date are required");
      return;
    }

    if ((projectCategoryId || projectId) && (!startDate || !endDate)) {
      showMessage("From Date and To Date are required");
      return;
    }

    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      showMessage("From Date should be less than or equal to To Date");
      return;
    }

    setLoading(true);
    try {
      setReports([]);
      // setPage(1);
      const user = StorageService.loginData();
      const res = await StockOutReportService.getReport({
        companyId: companyId || undefined,
        projectCategoryId: projectCategoryId || undefined,
        projectId: projectId || undefined,
        storeId: storeId || undefined,
        locationId: locationId || undefined,
        startDate: startDate || undefined,
        endDate: endDate || undefined,
        employeeId: user?.employeeId || undefined,
        roleId: user?.roleId || undefined,
        status: status || undefined,

        // ✅ NEW
        page: pageNumber,
        limit: limit,
      });

      // ✅ IMPORTANT
      setReports(res?.data || []);
      // const sortedReports = [...(res?.data || [])].sort((a, b) => {
      //   const dateA = new Date(a.transactionDate || 0).getTime();
      //   const dateB = new Date(b.transactionDate || 0).getTime();
      //   return dateA - dateB;   // Ascending (Oldest → Latest)
      // });

      // setReports(sortedReports);
      setTotalPages(res?.pagination?.totalPages || 0);
      setTotalRecords(res?.pagination?.total || 0);
      setPage(pageNumber);

    } catch (error) {
      console.error(error);
      setReports([]);
      showMessage("Error fetching stock out report");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (companyId) {
      loadDropdowns();

      const today = new Date();
      setEndDate(today.toISOString().split("T")[0]);
      loadReport();
    }
  }, [companyId]);

  const handleClearFilters = () => {
    setProjectCategoryId("");
    setProjectId("");
    setStoreId("");
    setLocationId("");
    setStatus("");
    setStartDate("");

    const today = new Date();
    setEndDate(today.toISOString().split("T")[0]);

    // ✅ RESET PAGINATION
    setPage(1);
    setTotalPages(0);

    loadReport(1);
  };

  const getAllReportData = async () => {
    try {
      let allData = [];
      let currentPage = 1;
      let totalPages = 1;

      do {
        const user = StorageService.loginData();
        const res = await StockOutReportService.getReport({
          companyId: companyId || undefined,
          projectCategoryId: projectCategoryId || undefined,
          projectId: projectId || undefined,
          storeId: storeId || undefined,
          locationId: locationId || undefined,
          startDate: startDate || undefined,
          endDate: endDate || undefined,
          employeeId: user?.employeeId || undefined,
          roleId: user?.roleId || undefined,
          status: status || undefined,
          page: currentPage,
          limit: 10
        });

        const data = res?.data || [];
        const pagination = res?.pagination || {};

        allData = [...allData, ...data];

        totalPages = pagination.totalPages || 1;
        currentPage++;

      } while (currentPage <= totalPages);

      return allData;

    } catch (error) {
      console.error("PDF error:", error);
      return [];
    }
  };

  const exportExcel = async () => {

    if (!projectCategoryId) {
      showMessage("Project Category is required");
      return;
    }

    if (!projectId) {
      showMessage("Project Name is required");
      return;
    }
    const allData = await getAllReportData();

    if (!allData.length) {
      showMessage("No data to export");
      return;
    }
    const toNumber = (value) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : 0;
    };
    const sortedData = [...allData].sort((a, b) => {
      const dateA = new Date(a.transactionDate || 0).getTime();
      const dateB = new Date(b.transactionDate || 0).getTime();
      return dateA - dateB;
    });

    const wb = XLSX.utils.book_new();
    const ws = {};
    ws["!merges"] = [];

    // Get filter labels
    let projectCategoryLabel = "All";
    if (projectCategoryId) {
      const found = projectCategories.find(pc => String(pc.id) === String(projectCategoryId));
      projectCategoryLabel = found?.categoryName || projectCategoryId;
    }

    let projectLabel = "All";
    if (projectId) {
      const found = projects.find(p => String(p.id || p.projectId) === String(projectId));
      projectLabel = formatProjectDisplay(found || { projectName: projectId });
    }

    let storeLabel = "All";
    if (storeId) {
      // const found = stores.find(s => String(s.id) === String(storeId));
      const found = stores.find(
        s => String(s.storeId || s.id) === String(storeId)
      );
      storeLabel = found?.storeName || storeId;
    }

    let locationLabel = "All";
    if (locationId) {
      const found = locations.find(l => String(l.id) === String(locationId));
      locationLabel = found?.locationName || locationId;
    }

    let row = 1;

    // STYLES
    const thin = { style: "thin" };
    const center = {
      horizontal: "center",
      vertical: "center",
      wrapText: true
    };

    // COMPANY NAME (Top Left)
    const companyName = activeCompany?.companyName || "";
    XLSX.utils.sheet_add_aoa(ws, [[companyName]], { origin: { r: 0, c: 0 } });

    // REPORT DATE (Top Right)
    XLSX.utils.sheet_add_aoa(
      ws,
      [[`Report Date: ${utility.formatExportDateTime(new Date())}`]],
      { origin: { r: 0, c: 8 } } // adjust column for right alignment
    );

    // STYLE COMPANY NAME
    ws[XLSX.utils.encode_cell({ r: 0, c: 0 })].s = {
      font: { bold: true, sz: 12 }
    };

    // STYLE REPORT DATE
    ws[XLSX.utils.encode_cell({ r: 0, c: 8 })].s = {
      alignment: { horizontal: "right" },
      font: { bold: true, sz: 11 }
    };
    // TITLE
    XLSX.utils.sheet_add_aoa(ws, [["Stock Out Report"]], { origin: { r: row, c: 0 } });
    ws["!merges"].push({ s: { r: row, c: 0 }, e: { r: row, c: 10 } });
    const titleCell = XLSX.utils.encode_cell({ r: row, c: 0 });
    ws[titleCell].s = {
      font: { bold: true, sz: 16 },
      alignment: center,
      border: {
        top: thin,
        bottom: thin,
        left: thin,
        right: thin
      }
    };
    row += 2;

    // FILTER INFO
    XLSX.utils.sheet_add_aoa(ws, [
      ["Project Category:", projectCategoryLabel, "", "Project:", projectLabel],
      ["Store:", storeLabel, "", "Location:", locationLabel],
      ["From Date:", startDate ? utility.formatDateDDMMMYYYY(startDate) : "-", "", "To Date:", endDate ? utility.formatDateDDMMMYYYY(endDate) : "-"],
      ["Status:", status || "All", "", "", ""]
    ], { origin: { r: row, c: 0 } });

    const filterLabelStyle = {
      font: { bold: true, sz: 10 },
      alignment: { horizontal: "left", vertical: "center" },
      border: { top: thin, bottom: thin, left: thin, right: thin }
    };

    const filterValueStyle = {
      font: { sz: 10 },
      alignment: { horizontal: "left", vertical: "center" },
      border: { top: thin, bottom: thin, left: thin, right: thin }
    };

    const boldLabelColumns = [0, 3];
    for (let i = 0; i < 4; i++) {
      for (let c = 0; c < 5; c++) {
        const cell = XLSX.utils.encode_cell({ r: row + i, c });
        if (!ws[cell]) continue;
        ws[cell].s = boldLabelColumns.includes(c) ? filterLabelStyle : filterValueStyle;
      }
    }
    row += 6;

    // TABLE HEADER
    // const headers = [
    //   "From Store",
    //   "To Location",
    //   "Issued To",
    //   "StockOut Date",
    //   "Voucher Number",
    //   "Item Category",
    //   "Item Name",
    //   "Item Desc",
    //   "UOM",
    //   "Qty",
    //   "Status"
    // ];

    // TABLE HEADER
    const headers = [
      "#",
      "StockOut Date",
      "From Store",
      "To Location",
      "Voucher No",
      "Transporter",
      "Vehicle No",
      "Issued To",
      "Item Category",
      "Item Name",
      "UOM",
      "Quantity",
      "Status"
    ];

    const headerRowIndex = row;
    XLSX.utils.sheet_add_aoa(ws, [headers], { origin: { r: row, c: 0 } });

    headers.forEach((_, colIndex) => {
      const cell = XLSX.utils.encode_cell({ r: row, c: colIndex });
      ws[cell].s = {
        font: { bold: true, sz: 11 },
        alignment: center,
        border: {
          top: thin,
          bottom: thin,
          left: thin,
          right: thin
        }
      };
    });
    row++;

    // TABLE DATA
    sortedData.forEach((reportRow, index) => {
      const qtyVal = toNumber(reportRow.quantity);
      const dateSerial = utility.convertDateToExcelSerial(reportRow.transactionDate);
      const rowData = [
        index + 1,
        dateSerial || "-",
        reportRow.storeName || "-",
        reportRow.locationName || "-",
        reportRow.vocherNo || "-",
        reportRow.transporterName || "-",
        reportRow.vehicleNo || "-",
        reportRow.receiverName || "-",
        reportRow.itemCategoryName || "-",
        reportRow.itemName || reportRow.itemCode || "-",
        reportRow.UOM || "-",
        qtyVal,
        reportRow.status || "-"
      ];

      XLSX.utils.sheet_add_aoa(ws, [rowData], { origin: { r: row, c: 0 } });

      rowData.forEach((_, colIndex) => {
        const cell = XLSX.utils.encode_cell({ r: row, c: colIndex });
        const isNumeric = colIndex === 0 || colIndex === 11;
        const isDate = colIndex === 1;
        ws[cell].s = {
          font: { sz: 10 },
          alignment: { horizontal: isNumeric ? "right" : (isDate ? "center" : "left"), vertical: "center" },
          border: {
            top: thin,
            bottom: thin,
            left: thin,
            right: thin
          }
        };

        // Sl No
        if (colIndex === 0) {
          ws[cell].t = "n";
          ws[cell].v = index + 1;
          ws[cell].z = "0";
        }

        // StockOut Date column
        if (colIndex === 1 && dateSerial) {
          ws[cell].v = dateSerial;
          ws[cell].t = "n";
          ws[cell].z = "dd-mm-yyyy";
        }

        // Quantity column
        if (colIndex === 11) {
          ws[cell].t = "n";
          ws[cell].v = qtyVal;
          ws[cell].z = "#,##0.000";
        }
      });
      row++;
    });

    ws["!autofilter"] = {
      ref: XLSX.utils.encode_range({
        s: { r: headerRowIndex, c: 0 },
        e: { r: row - 1, c: headers.length - 1 }
      })
    };

    // Totals Row
    const totalQuantity = sortedData.reduce((sum, item) => sum + toNumber(item.quantity), 0);
    const totalsRow = Array(13).fill("");
    totalsRow[10] = "Total:";
    totalsRow[11] = totalQuantity;
    XLSX.utils.sheet_add_aoa(ws, [totalsRow], { origin: { r: row, c: 0 } });

    for (let c = 0; c < 13; c++) {
      const cell = XLSX.utils.encode_cell({ r: row, c });
      const isNumeric = c === 11;
      ws[cell].s = {
        font: { bold: true, sz: 10 },
        alignment: { horizontal: isNumeric || c === 10 ? "right" : "left", vertical: "center" },
        border: { top: thin, bottom: thin, left: thin, right: thin }
      };
      if (isNumeric) {
        ws[cell].t = "n";
        ws[cell].v = totalQuantity;
        ws[cell].z = "#,##0.000";
      }
    }
    row++;

    // Set column widths
    ws["!cols"] = [
      { wch: 8 },
      { wch: 15 },
      { wch: 20 },
      { wch: 20 },
      { wch: 18 },
      { wch: 20 },
      { wch: 18 },
      { wch: 18 },
      { wch: 30 },
      { wch: 40 },
      { wch: 10 },
      { wch: 15 },
      { wch: 14 }
    ];

    XLSX.utils.book_append_sheet(wb, ws, "StockOutReport");
    // XLSX.writeFile(wb, "StockOutReport.xlsx");
    const fileName =
      `StockOutRPT_${projectCategoryLabel}_${projectLabel}_${utility.formatDateDMY(new Date()).replace(/\//g, "-")}.xlsx`;

    XLSX.writeFile(wb, fileName);
  };

  const exportPdf = async () => {

    if (!projectCategoryId) {
      showMessage("Project Category is required");
      return;
    }

    if (!projectId) {
      showMessage("Project Name is required");
      return;
    }
    const allData = await getAllReportData();

    if (!allData.length) {
      showMessage("No data to export");
      return;
    }


    // Get filter labels
    let projectCategoryLabel = "All";
    if (projectCategoryId) {
      const found = projectCategories.find(pc => String(pc.id) === String(projectCategoryId));
      projectCategoryLabel = found?.categoryName || projectCategoryId;
    }

    let projectLabel = "All";
    if (projectId) {
      const found = projects.find(p => String(p.id || p.projectId) === String(projectId));
      projectLabel = formatProjectDisplay(found || { projectName: projectId });
    }

    let storeLabel = "All";
    if (storeId) {
      // const found = stores.find(s => String(s.id) === String(storeId));
      const found = stores.find(
        s => String(s.storeId || s.id) === String(storeId)
      );
      storeLabel = found?.storeName || storeId;
    }

    let locationLabel = "All";
    if (locationId) {
      const found = locations.find(l => String(l.id) === String(locationId));
    locationLabel = found?.locationName || locationId;
    }

    const doc = new jsPDF("landscape");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const companyName = activeCompany?.companyName || "Company";
    
    // Pre-convert logo to Data URL for 100% reliable rendering
    let pdfLogo = null;
    try {
      pdfLogo = await getPdfLogoDataUrl(logo);
    } catch (e) {
      console.error("PDF logo load error:", e);
    }

    const drawHeader = (yPos) => {
      doc.setFontSize(12);
      doc.setFont(undefined, "bold");
      const companyNameWidth = doc.getTextWidth(companyName);
      const logoWidth = 5;
      const logoHeight = 10;
      const logoX = 14 + 6 + (companyNameWidth - logoWidth) / 2;
      const logoY = yPos;

      if (pdfLogo) {
        doc.addImage(pdfLogo, "PNG", logoX, logoY, logoWidth, logoHeight);
      }
      doc.text(companyName, 14 + 6, yPos + 15);

      const reportPrefix = "Report Date: ";
      const reportDateStr = utility.formatExportDateTime(new Date());

      doc.setFont(undefined, "bold");
      doc.setFontSize(10);
      const prefixWidth = doc.getTextWidth(reportPrefix);

      doc.setFont(undefined, "normal");
      doc.setFontSize(10);
      const dateWidth = doc.getTextWidth(reportDateStr);

      const totalWidth = prefixWidth + dateWidth;
      const right = pageWidth - 14;
      const startX = right - totalWidth;

      doc.setFont(undefined, "bold");
      doc.text(reportPrefix, startX, yPos + 15);

      doc.setFont(undefined, "normal");
      doc.text(reportDateStr, startX + prefixWidth, yPos + 15);

      const title = "Stock Out Report";
      doc.setFontSize(16);
      doc.setFont(undefined, "bold");
      const titleWidth = doc.getTextWidth(title);
      const centerX = pageWidth / 2;
      doc.text(title, centerX, yPos + 27, { align: "center" });

      doc.setLineWidth(0.3);
      doc.line(centerX - titleWidth / 2, yPos + 29, centerX + titleWidth / 2, yPos + 29);
    };

    let yPosition = 8;
    drawHeader(yPosition);

    doc.setFontSize(9);
    doc.setFont(undefined, "bold");

    let xLeft = 14;
    let xRight = 115;
    let yHeader = 44;
    doc.text("Project Category:", xLeft, yHeader);
    doc.setFont(undefined, "normal");
    doc.text(String(projectCategoryLabel), xLeft + 35, yHeader);

    doc.setFont(undefined, "bold");
    doc.text("Project:", xLeft, yHeader + 5);
    doc.setFont(undefined, "normal");
    doc.text(String(projectLabel), xLeft + 35, yHeader + 5);

    doc.setFont(undefined, "bold");
    doc.text("From Store:", xLeft, yHeader + 10);
    doc.setFont(undefined, "normal");
    doc.text(String(storeLabel), xLeft + 35, yHeader + 10);

    doc.setFont(undefined, "bold");
    doc.text("To Location:", xRight, yHeader);
    doc.setFont(undefined, "normal");
    doc.text(String(locationLabel), xRight + 25, yHeader);

    doc.setFont(undefined, "bold");
    doc.text("From Date:", xRight, yHeader + 5);
    doc.setFont(undefined, "normal");
    doc.text(startDate ? utility.formatDateDDMMMYYYY(startDate) : "-", xRight + 25, yHeader + 5);

    doc.setFont(undefined, "bold");
    doc.text("To Date:", xRight, yHeader + 10);
    doc.setFont(undefined, "normal");
    doc.text(endDate ? utility.formatDateDDMMMYYYY(endDate) : "-", xRight + 25, yHeader + 10);

    doc.setFont(undefined, "bold");
    doc.text("Status:", xLeft, yHeader + 15);
    doc.setFont(undefined, "normal");
    doc.text(status || "All", xLeft + 35, yHeader + 15);

    const sortedData = [...allData].sort((a, b) => {
      const dateA = new Date(a.transactionDate || 0).getTime();
      const dateB = new Date(b.transactionDate || 0).getTime();
      return dateA - dateB;
    });

    const body = sortedData.map((row, index) => [
      index + 1,
      utility.formatDateDDMMMYYYY(row.transactionDate),
      row.storeName || "-",
      row.locationName || "-",
      row.vocherNo || "-",
      row.transporterName || "-",
      row.vehicleNo || "-",
      row.receiverName || "-",
      row.itemCategoryName || "-",
      row.itemName || row.itemCode || "-",
      row.UOM || "-",
      row.quantity ?? "-",
      row.status || "-"
    ]);

    autoTable(doc, {
      startY: 72,

      head: [[
        "S.No",
        "StockOut Date",
        "From Store",
        "To Location",
        "Voucher No",
        "Transporter",
        "Vehicle No",
        "Issued To",
        "Item Category",
        "Item Name",
        "UOM",
        "Quantity",
        "Status"
      ]],
      body,

      theme: "grid",

      styles: {
        fontSize: 8,
        lineColor: [0, 0, 0],
        lineWidth: 0.15,
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0]
      },

      alternateRowStyles: {
        fillColor: [255, 255, 255]
      },

      headStyles: {
        fillColor: [230, 230, 230],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center"
      },

      footStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold"
      },

      columnStyles: {
        0: { halign: "right" },
        1: { halign: "center" },
        2: { halign: "left" },
        3: { halign: "left" },
        4: { halign: "left" },
        5: { halign: "left" },
        6: { halign: "left" },
        7: { halign: "left" },
        8: { halign: "left" },
        9: { halign: "left" },
        10: { halign: "left" },
        11: { halign: "right" },
        12: { halign: "left" }
      },

      margin: {
        top: 40,
        left: 14,
        right: 14,
        bottom: 25
      },

      didDrawPage: function (data) {
        if (data.pageNumber === 1) return;
        drawHeader(8);
      }
    });

    const pdfPageCount = doc.getNumberOfPages();

    for (let i = 1; i <= pdfPageCount; i++) {
      doc.setPage(i);
      if (i === pdfPageCount) {
        doc.setFont(undefined, "bold");
        doc.setFontSize(8);
        const footerTop = pageHeight - 20;
        doc.text("Prepared By", 25, footerTop);
        doc.text("Checked By", pageWidth / 2, footerTop, { align: "center" });
        doc.text("Approved By", pageWidth - 25, footerTop, { align: "right" });
      }
      doc.setFontSize(9);
      doc.setFont(undefined, "normal");
      doc.text(`Page ${i} of ${pdfPageCount}`, pageWidth / 2, pageHeight - 10, { align: "center" });
    }

    // doc.save("StockOutReport.pdf");
    const pdfName =
      `StockOutRPT_${projectCategoryLabel}_${projectLabel}_${utility.formatDateDMY(new Date()).replace(/\//g, "-")}.pdf`;

    doc.save(pdfName);
  };

  return (
    <>
      <Breadcrumb pageTitle="Stock Out Report" secondTitle="Reports" />

      <MessageDialog
        message={message}
        type={msgType}
        setMessage={setMessage}
        setMsgType={setMsgType}
      />

      <div className="card p-4 bg-white shadow-sm">
        <div className="row g-3 mb-3">
          <div className="col-md-3">
            <label className="form-label">Project Category <span className="text-danger">*</span></label>
            <select
              className="form-select"
              value={projectCategoryId}
              onChange={(e) => {
                setProjectCategoryId(e.target.value);
                setProjectId("");
                setStoreId("");
                setLocationId("");
                setStartDate("");
              }}
            >
              <option value="">Select Project Category</option>
              {projectCategories.map((category) => (
                <option key={category.id} value={category.id}>
                  {category.categoryName}
                </option>
              ))}
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label">Project Name <span className="text-danger">*</span></label>

            <select
              className="form-select"
              value={projectId}
              onChange={(e) => {
                const selectedProjectId = e.target.value;

                setProjectId(selectedProjectId);
                setStoreId("");
                setLocationId("");

                loadStoresByProject(selectedProjectId);   // ✅ ADD THIS

                if (!selectedProjectId) {
                  setStartDate("");
                  return;
                }

                const selectedProject = projects.find(
                  (p) => String(p.id || p.projectId) === String(selectedProjectId)
                );

                if (selectedProject?.projectStartDate) {
                  const formattedDate = new Date(selectedProject.projectStartDate)
                    .toISOString()
                    .split("T")[0];

                  setStartDate(formattedDate);
                } else {
                  setStartDate("");
                }
              }}
              disabled={!projectCategoryId}
            >
              <option value="">Select Project Name</option>

              {filteredProjects.map((project) => (
                <option key={project.projectId || project.id} value={project.projectId || project.id}>
                  {formatProjectDisplay(project)}
                </option>
              ))}
            </select>

          </div>

          <div className="col-md-3">
            <label className="form-label"> From Store</label>

            <select
              className="form-select"
              value={storeId}
              onChange={(e) => {
                const selectedStoreId = e.target.value;

                setStoreId(selectedStoreId);
                setLocationId("");

                loadLocationsByProjectAndStore(projectId, selectedStoreId);
              }}
              disabled={!projectId}
            >
              <option value="">All</option>

              {stores.map((store) => (
                <option key={store.id} value={store.storeId}>
                  {store.storeName}
                </option>
              ))}
            </select>

          </div>

          <div className="col-md-3">
            <label className="form-label">To Location</label>

            <select
              className="form-select"
              value={locationId}
              onChange={(e) => setLocationId(e.target.value)}
              disabled={!storeId}
            >
              <option value="">All</option>

              {locations.map((location) => (
                <option key={location.id} value={location.id}>
                  {location.locationName}
                </option>
              ))}
            </select>

          </div>

          <div className="col-md-3">
            <label className="form-label">Status</label>
            <select
              className="form-select"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">All</option>
              <option value="Approved">Approved</option>
              <option value="Pending">Pending</option>
            </select>
          </div>

          <div className="col-md-3">
            <label className="form-label">From Date <span className="text-danger">*</span></label>
            <input
              type="date"
              className="form-control"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <label className="form-label">To Date <span className="text-danger">*</span></label>
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
        </div>

        <div className="mb-3 d-flex justify-content-end align-items-center">

          <div className="d-flex gap-2">

            <button className="btn btn-secondary" onClick={handleClearFilters}>
              <i className="ti ti-refresh me-1"></i>
              Clear
            </button>

            <button className="btn btn-primary" onClick={() => loadReport(1)} disabled={loading}>
              <i className="ti ti-search me-1"></i>
              {loading ? "Searching..." : "View Report"}
            </button>
          </div>
        </div>
        <hr />
        <div className="mb-3 d-flex justify-content-end align-items-center">
          <div className="d-flex gap-2">
            <button className="btn btn-success" onClick={exportPdf} disabled={loading}>
              <i className="ti ti-file-type-pdf me-1"></i>
              Export PDF
            </button>

            <button className="btn btn-success" onClick={exportExcel} disabled={loading}>
              <i className="ti ti-file-spreadsheet me-1"></i>
              Export Excel
            </button>
          </div>


        </div>

        <div className="table-responsive">
          <table className="table table-bordered table-striped mb-0">
            <thead className="table-light">

              {/* <tr>
                <th>S.no</th>
                <th>From Store</th>
                <th>To Location</th>
                <th>Issued To</th>
                <th>StockOut Date</th>
                <th>Voucher Number</th>
                <th>Item Category</th>
                <th>Item Name</th>
                <th>Item Desc</th>
                <th>UOM</th>
                <th>Qty</th>
                <th>Status</th>
              </tr> */}

              <tr>
                <th>S.No</th>
                <th>StockOut Date</th>
                <th>From Store</th>
                <th>To Location</th>
                <th>Voucher No</th>
                <th>Transporter</th>
                <th>Vehicle No</th>
                <th>Issued To</th>
                <th>Item Category</th>
                <th>Item Name</th>
                <th>UOM</th>
                <th>Quantity</th>
                <th>Status</th>
              </tr>

            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="13" className="text-center">
                    <div className="spinner-border text-primary" />
                  </td>
                </tr>
              ) : reports.length === 0 ? (
                <tr>
                  <td colSpan="13" className="text-center">
                    No data found
                  </td>
                </tr>
              ) : (
                reports.map((row, index) => (
                  <tr key={`${row.id}-${index}`}>
                    {/* <td>{(page - 1) * limit + index + 1}</td>
                    <td>{row.storeName || "-"}</td>
                    <td>{row.locationName || "-"}</td>
                    <td>{row.receiverName || "-"}</td>
                    <td>{utility.formatDateDDMMMYYYY(row.transactionDate)}</td>
                    <td>{row.vocherNo || "-"}</td>
                    <td>{row.itemCategoryName || "-"}</td>
                    <td>{row.itemName || row.itemCode || "-"}</td>
                    {/* <td>{row.itemDescription || "-"}</td> */}
                    {/* <td>{row.UOM || "-"}</td>
                    <td>{row.quantity ?? "-"}</td> */}
                    <td>{(page - 1) * limit + index + 1}</td>

                    <td>{utility.formatDateDDMMMYYYY(row.transactionDate)}</td>

                    <td>{row.storeName || "-"}</td>

                    <td>{row.locationName || "-"}</td>

                    <td>{row.vocherNo || "-"}</td>

                    <td>{row.transporterName || "-"}</td>

                    <td>{row.vehicleNo || "-"}</td>

                    <td>{row.receiverName || "-"}</td>

                    <td>{row.itemCategoryName || "-"}</td>

                    <td>{row.itemName || row.itemCode || "-"}</td>

                    <td>{row.UOM || "-"}</td>

                    <td>{row.quantity ?? "-"}</td>

                    {/* <td>
                      <span
                        style={{
                          backgroundColor:
                            row.status?.toUpperCase().trim() === "APPROVED"
                              ? "#28a745"
                              : row.status?.toUpperCase().trim() === "PENDING"
                                ? "#ffc107"
                                : "#6c757d",
                          color:
                            row.status?.toUpperCase().trim() === "PENDING"
                              ? "#000"
                              : "#fff",
                          padding: "4px 10px",
                          borderRadius: "20px",
                          fontSize: "11px",
                          fontWeight: "600",
                          display: "inline-block"
                        }}
                      >
                        {row.status || "-"}
                      </span>
                    </td> */}

                    <td>
                      <span
                        style={{
                          backgroundColor:
                            (row.status || "").trim().toUpperCase() === "APPROVED"
                              ? "#1de9b6"      // Green
                              : "#5b6b79",     // Grey

                          color: "#fff",

                          padding: "4px 10px",
                          borderRadius: "20px",
                          fontSize: "11px",
                          fontWeight: "600",
                          display: "inline-block",
                          minWidth: "75px",
                          textAlign: "center"
                        }}
                      >
                        {row.status || "-"}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-3">

              {/* TOTAL RECORDS */}
              <div>
                Total Records: <strong>{totalRecords}</strong>
              </div>

              {/* PAGINATION BUTTONS */}
              <div className="d-flex gap-2">

                <button
                  className="btn btn-sm btn-secondary"
                  disabled={page === 1}
                  onClick={() => loadReport(page - 1)}
                >
                  Prev
                </button>

                {[...Array(totalPages)].map((_, i) => (
                  <button
                    key={i}
                    className={`btn btn-sm ${page === i + 1 ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => loadReport(i + 1)}
                  >
                    {i + 1}
                  </button>
                ))}

                <button
                  className="btn btn-sm btn-secondary"
                  disabled={page === totalPages}
                  onClick={() => loadReport(page + 1)}
                >
                  Next
                </button>

              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
